import { forwardRef, useState } from 'react';

export interface CheckboxProps {
  /** Label */
  label?: string;
  /** Checkbox  */
  id?: string;
  /** Title on label */
  title?: string;
  /** Name */
  name?: string;
  /** Value */
  value?: string;
  /** Whether the checkbox is checked */
  checked?: string | boolean;
  /** Whether the checkbox is disabled */
  disabled?: boolean;
  /** Whether the checkbox is required */
  required?: boolean;
  /** Whether the checkbox has an error */
  error?: boolean;
  /** Small */
  small?: boolean;
  /** Optional on change handler */
  onChange?: (checked: boolean) => void;
  /** Additional class */
  className?: string;
}

/** A checkbox */
export const Checkbox = forwardRef(
  (
    {
      label,
      title,
      name,
      value,
      checked,
      disabled,
      error,
      small,
      onChange,
      className,
      ...props
    }: CheckboxProps,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ref: any,
  ) => {
    const [isChecked, setChecked] = useState<string | boolean>(!!checked);

    // State managed by parent
    if (typeof checked !== 'undefined' && checked !== isChecked) {
      setChecked(checked);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleChange = (e: any) => {
      setChecked(e.target.checked);

      if (onChange) {
        onChange(e.target.checked);
      }
    };

    return (
      <label
        className={['checkbox', small && 'checkbox--small', className].join(
          ' ',
        )}
        data-error={(error && '1') || null}
        title={title}
      >
        <input
          ref={ref}
          className="checkbox__input"
          type="checkbox"
          name={name}
          value={value}
          disabled={disabled ? true : undefined}
          checked={isChecked as boolean}
          autoComplete="off"
          onChange={handleChange}
          {...props}
        />
        <span className="checkbox__label">{label}</span>
      </label>
    );
  },
);
